<template>
  <el-dialog :title="$t('customer::customer-list::tag_batch_add')" :visible.sync="visiable" width="600px">
    <el-row style="display: flex; margin-bottom: 20px">
      <div style="white-space: nowrap">{{ $t('customer::customer-list::customer_name') }}</div>
      <div style="margin-left: 10px">
        <span v-for="(item, index) in selectList" :key="item.id">
          {{ item.firstName + ' ' + item.lastName }}
          <span v-if="index < selectList.length - 1">,</span>
        </span>
      </div>
    </el-row>
    <el-row style="display: flex">
      <div>
        {{ $t('customer::customer-list::tag') }}
        <p class="tips">{{ $t('customer::customer-list::ten_limit') }}</p>
      </div>
      <div>
        <el-select
          :placeholder="$t('customer::customer-list::select_tag')"
          v-model="tags"
          style="margin-left: 10px;width: 300px"
          multiple
          collapse-tags
          :multiple-limit="10"
          :popper-append-to-body="false"
        >
          <el-option v-for="item in tagList" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </div>
    </el-row>
    <div slot="footer">
      <el-button @click="visiable = false">{{ $t('customer::customer-list::cancel') }}</el-button>
      <el-button type="primary" @click="setTag" :loading="loading">{{ $t('customer::customer-list::confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { batchSetTag } from '@/server/customers'
export default {
  props: {
    value: {},
    selectList: {
      type: Array,
      default: () => []
    },
    tagList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visiable: this.value,
      tags: [],
      loading: false
    }
  },
  methods: {
    async setTag() {
      if (this.tags.length === 0) return this.$message.warning(this.$t('customer::customer-list::select_tag_one'))
      this.loading = true
      const { data } = await batchSetTag({
        customerIdList: this.selectList.map(item => item.id),
        customerTagIdList: this.tags
      })
      this.loading = false
      if (data.code === this.$code) {
        this.$message.success(this.$t('customer::customer-list::select_tag_success'))
        this.visiable = false
        this.tags = []
        this.$emit('getData')
      }
    }
  },
  watch: {
    value(val) {
      this.visiable = val
    },
    visiable(val) {
      this.$emit('input', val)
    }
  }
}
</script>

<style lang="scss" scoped>
.tips {
  color: #999;
  font-size: 12px;
}
</style>
